module.exports = __webpack_public_path__ + "static/media/workPvcCoatings2.43b4d5b8.jpg";